const currencies = {
  EUR: { changeRatio: 1, sign: '€' },
  CHF: { changeRatio: 1, sign: 'CHF' },
};

export const currentCurrency = window.location.hostname.endsWith(
  'bilendi-ux.ch',
)
  ? 'CHF'
  : 'EUR';

const currentRatio = currencies[currentCurrency].changeRatio;
export const currentCurrencySign = currencies[currentCurrency].sign;

export const convertToCurrentCurrency = (amount: number) => {
  return amount * currentRatio;
};
